var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "vcenter" }, [
    _c(
      "form",
      {
        staticClass: "vcenter-form",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit($event)
          }
        }
      },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("passwordreset.title")))]),
        _vm.done
          ? _c("b-message", { attrs: { type: "is-success", "has-icon": "" } }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("passwordreset.message1")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("passwordreset.message2")))])
            ])
          : [
              _vm.errorMessage
                ? _c("b-message", { attrs: { type: "is-danger" } }, [
                    _vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")
                  ])
                : _vm._e(),
              _c(
                "b-field",
                { attrs: { label: _vm.$t("passwordreset.field-title") } },
                [
                  _c("b-input", {
                    attrs: { type: "email" },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "form-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    attrs: { type: "submit" }
                  },
                  [_vm._v(_vm._s(_vm.$t("passwordreset.btn-valid")))]
                ),
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "small", attrs: { to: "/" } },
                      [_vm._v(_vm._s(_vm.$t("passwordreset.btn-back")))]
                    )
                  ],
                  1
                )
              ])
            ],
        _c("b-loading", {
          attrs: { active: _vm.loading, "is-full-page": false }
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }